import ProtectedRouter from "@/context/auth/ProtectedRouter";
import { TenantProvider } from "@/context/TenantContext";
import { useTenant } from "@/context/useTenant";
import { getAccessToken } from "@/lib/storeManager";
import MainLayout from "@/layouts/MainLayout";
import StarterLayout from "@/layouts/StarterLayout";
import NotFoundPage from "@/pages/NotFoundPage";
import routes from "@/utils/routes";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import BiteBalanceApp from "./projects/Admin_Bite_Balance/bite-balance/src/App";
import { applyBiteBalancePageMeta } from "./projects/Admin_Bite_Balance/bite-balance/src/lib/pageMeta";
import "./projects/Admin_Bite_Balance/bite-balance/src/index.css";

function App() {
  const path = window.location.pathname;

  if (path === "/" || path === "" || path === "/login") {
    window.location.replace("/bite-balance/admin/login");
    return null;
  }

  if (path.startsWith("/bite-balance")) {
    applyBiteBalancePageMeta();
    return <BiteBalanceApp basename="/bite-balance" />;
  }

  return (
    <TenantProvider>
      <AppWithRouter />
    </TenantProvider>
  );
}

const AppWithRouter = () => {
  const { tenantId } = useTenant();

  // If no tenant ID is available, show a tenant configuration error
  if (!tenantId) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="mb-4 text-2xl font-bold">Tenant ID Not Configured</h1>
          <p className="text-gray-600">
            Please set VITE_X_TENANTID in your .env file
          </p>
        </div>
      </div>
    );
  }
  const publicRoutes = routes.find(m => m.type === "public")?.routes ?? [];
  const authRoutes = routes.find(m => m.type === "auth")?.routes ?? [];
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<TopLevelComponent />}>
          {publicRoutes.map(({ path, element: Page }) => (
            <Route key={path} path={path} element={<StarterLayout />}>
              <Route index element={<Page />} />
            </Route>
          ))}

          {/* Protected routes */}
          <Route element={<ProtectedRouter />}>
            <Route element={<MainLayout />}>
              {authRoutes.map(({ path, element: Page }) => (
                <Route key={path} path={path} element={<Page />} />
              ))}
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

const TopLevelComponent = () => {
  return <Outlet />;
};

export default App;
